const request = {
  outTime: "หมดเวลาการร้องขอ",
  downFail: "ดาวน์โหลดล้มเหลว",
  Network: "เครือข่ายมีข้อผิดพลาด"
} 
export default request